import { AfterViewInit, Component, DestroyRef, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IconComponent } from '@lbca-shared/icon';
import { timer } from 'rxjs';
import { ToastService, ToastType } from 'services/toast.service';

@Component({
	selector: 'lbca-toast',
	imports: [IconComponent],
	templateUrl: './toast.component.html',
	styleUrl: './toast.component.scss',
})
export class ToastComponent implements AfterViewInit {
	private readonly toastService = inject(ToastService);
	readonly #destroyRef = inject(DestroyRef);

	protected readonly toast = input.required<ToastType>();

	ngAfterViewInit() {
		timer(50)
			.pipe(takeUntilDestroyed(this.#destroyRef))
			.subscribe(() => (this.toast().progress = '0'));
	}

	removeToast() {
		if (this.toast().id) this.toastService.removeById(this.toast().id!);
	}
}
